import { WithStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useState } from "react";

import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import withMobileDialog, { WithMobileDialog } from "@material-ui/core/withMobileDialog/withMobileDialog";
import HideAllTabOptions from "./options/hide-all-tab";
const styles = () =>
    createStyles({
        paper: {
            "@media (min-width: 737px)": {
                width: "600px",
                minWidth: "600px"
            }
        },
        contentWrap: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            paddingTop: 5
        }
    });
const Settings = ({
    classes,
    fullScreen,
    handleClose
}: WithStyles<typeof styles> &
    WithMobileDialog & {
        fullScreen: boolean;
        handleClose: () => void;
    }) => {
    const [expanded, setExpanded] = useState<string | false>("hideAllTab");
    const onGeneralExpPanelChange = (panel: string) => (event: any, newExpand: boolean) => {
        setExpanded(newExpand ? panel : false);
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={true}
            onClose={handleClose}
            classes={{
                paper: classes.paper
            }}
            aria-labelledby="dialog-settings"
        >
            <DialogTitle id="settings-dialog-title">Settings</DialogTitle>
            <DialogContent>
                <div className={classes.contentWrap}>
                    <HideAllTabOptions
                        handleClose={handleClose}
                        expanded={expanded}
                        handleExpansionChange={onGeneralExpPanelChange}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default withMobileDialog()(withStyles(styles)(Settings));
